@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.message {
  @include sm-sohne;
  color: var(--dark-80);
  display: flex;
  flex-direction: column;
  gap: 8px;
  word-break: break-word;
  overflow-wrap: break-word;

  [data-nextgen-chat='on'] & {
    @include md-sohne;
    line-height: 160%;
    color: var(--dark-90);
  }

  &.user {
    padding: 9px 11px;
    background-color: var(--dark-4);
    border-radius: 10px;
    align-self: flex-end;

    [data-nextgen-chat='on'] & {
      display: flex;
      padding: 10px 16px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 12px;
    }
  }
}

.splitMessage {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-end;
  align-self: flex-end;
}

.userMessageWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
  align-self: stretch;
}
